import Highcharts from 'highcharts';

export const createDefaultTitleOptions = (
): Highcharts.TitleOptions => ({
  text: '',
});
